import { ObligationRulesGeneratorConfirmationDecisionType } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

export type BulkConfirmationDecision = {
  filingCompositeId: string;
  fiscalYear: number;
  decision: ObligationRulesGeneratorConfirmationDecisionType;
};

export async function bulkDecideApplyDenyForComplianceItems(
  corporationId: number,
  decisions: BulkConfirmationDecision[],
  token?: string
): Promise<Response | null> {
  return fetcher(
    'compliance/confirmation/bulk',
    { method: 'POST', body: { corporationId, decisions } },
    token
  );
}
